import { Link } from 'react-router-dom';
import type { MovieItem } from '@/types/content';

export default function MovieCard({ movie }: { movie: MovieItem }) {
  return (
    <Link
      to={`/movie/${movie.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative w-full overflow-hidden bg-background-100" style={{ aspectRatio: '3 / 4' }}>
        <img
          src={movie.cover}
          alt={movie.title}
          title={`${movie.title} - 靠逼影视推荐`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-primary-500 px-2 py-1 text-xs font-bold text-background-50">
          <i className="ri-star-fill" />
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute left-2 top-2 rounded-md bg-foreground-950/70 px-2 py-1 text-[11px] font-medium text-white">
          {movie.type}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3 md:p-4">
        <h3 className="line-clamp-1 font-heading text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
          {movie.title}
        </h3>
        <p className="mt-1.5 line-clamp-1 text-xs text-foreground-500">{movie.genre}</p>
        <div className="mt-auto flex items-center justify-between pt-2 text-[11px] text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line" />
            {movie.year}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-map-pin-line" />
            {movie.region}
          </span>
        </div>
      </div>
    </Link>
  );
}